import React from "react";

function EditDeleteActions({ edit, onEdit }) {
  return (
    <div className="action-bar-customer-ledger no-print d-flex flex-wrap gap-2">
      <button className="btn-action" onClick={() => onEdit(!edit)}>
        <svg
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          viewBox="0 0 24 24"
          width="18"
          height="18"
        >
          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
        </svg>
        {edit ? "Close Edit" : "Edit"}
      </button>

      {/* <button className="btn-action" onClick={onDelete}>
        <svg
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          viewBox="0 0 24 24"
          width="18"
          height="18"
        >
          <polyline points="3 6 5 6 21 6" />
          <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
          <path d="M10 11v6" />
          <path d="M14 11v6" />
          <path d="M9 6V4h6v2" />
        </svg>
        Delete
      </button> */}
    </div>
  );
}

export default EditDeleteActions;
